import React from 'react'
import Icon from 'components/elements/Icon'

import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import { Button } from './style'

const Search = () => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <Button onClick={() => setActiveState({ searchOpen: 'search' })}>
      <Icon name="search" link style={{ color: '#A1C181' }} size="massive" />
      <h4>Add Cards From Search</h4>
    </Button>
  )
}

export default Search
